export { useTheme, ThemeProvider } from 'next-themes';
export type Theme = 'light' | 'dark' | 'system';
